import { PAGINATION_LIMIT, SortDirection } from '../../../constants';
import { LicenseTypeNature } from '../../../types';

import { SearchSelectField } from '../configs';
import type { LicensesState } from './types';

export const initialState: Record<LicenseTypeNature, LicensesState> = {
  [LicenseTypeNature.LPCO]: {
    newLicenses: {
      data: [],
      isLoading: false,
      totalCount: 0,
      sortConfig: {
        field: SearchSelectField.lastOperationDate,
        mode: SortDirection.DESC,
      },
      pagination: {
        size: PAGINATION_LIMIT,
        currentPage: 1,
      },
    },
    licenses: {
      data: [],
      isLoading: false,
      totalCount: 0,
      sortConfig: {
        field: SearchSelectField.lastOperationDate,
        mode: SortDirection.DESC,
      },
      pagination: {
        size: PAGINATION_LIMIT,
        currentPage: 1,
      },
    },
  },
  [LicenseTypeNature.EPHYTO]: {
    newLicenses: {
      data: [],
      isLoading: false,
      totalCount: 0,
      sortConfig: {
        field: SearchSelectField.lastOperationDate,
        mode: SortDirection.DESC,
      },
      pagination: {
        size: PAGINATION_LIMIT,
        currentPage: 1,
      },
    },
    licenses: {
      data: [],
      isLoading: false,
      totalCount: 0,
      sortConfig: {
        field: SearchSelectField.lastOperationDate,
        mode: SortDirection.DESC,
      },
      pagination: {
        size: PAGINATION_LIMIT,
        currentPage: 1,
      },
    },
  },
};
